import { useEffect } from "react";

import { useAtom, useAtomValue } from "jotai";
import { useBenefitPaymentsData } from "pages/Dashboard/hooks/useBenefitPaymentsData";
import { selectedBenefitCurrencyAtom, selectedClientAtom } from "store/index";

export function useSetDefaultBenefitCurrency() {
  const [selectedCurrency, setSelectedCurrency] = useAtom(selectedBenefitCurrencyAtom);
  const selectedClient = useAtomValue(selectedClientAtom);
  const paymentData = useBenefitPaymentsData();

  const payments = paymentData.rawPayments || {};
  const currencyList = Object.keys(payments).map((keyAsCurrency) => {
    return keyAsCurrency;
  });



  useEffect(() => {
    if (!currencyList.length) {
      return;
    }
    if (currencyList.includes(selectedCurrency)) {
      return;
    }
    setSelectedCurrency(currencyList[0]);
  }, [currencyList, selectedClient]);
}
